import {createSlice} from '@reduxjs/toolkit'

export const dropdownSlice = createSlice({
    name: 'dropdown',
    initialState: {},
    reducers: {
        onOpen: (state, action) => {
            state[action.payload.name] = {
                open: true
            }
        },
        onClose: (state, action) => {
            state[action.payload.name] = {
                open: false
            }
        },
        setKeyPressed: (state, action) => {
            state[action.payload.name] = {
                ...state[action.payload.name],
                keyPressed: action.payload.keyPressed
            }
        }
    }
})

export const {
    onOpen,
    onClose,
    setKeyPressed
} = dropdownSlice.actions;

export default dropdownSlice.reducer;